import React from 'react';

import { List } from '../components/checkout/';
import { PrivateLayout as Route } from '../components/PrivateLayout';

export default [
  <Route path="/checkout" component={List} exact strict key="list" />
];
